import { moderation } from './misc'

export default {
  title: 'Правила',

  titles: {
    actions: 'Действия',
    conditions: 'Условия'
  },

  labels: {
    title: 'Название правила',
    type: 'Тип',
    text: 'Текст',
    sender: 'Отправитель',
    routingRule: 'Правило',
    condition: 'Условие',
    providerGroup: 'Группа провайдеров',
    percentage: 'Процент',
    search: 'Поиск',
    textToCheck: 'Текст для проверки',
    phone: 'Телефон для проверки',
    keywords: 'Списки ключевых слов',
    contactList: 'Адресные книги',
    messagePattern: 'Шаблоны для модерации',
    fallbacks: 'Переотправления',
    buttons: 'Кнопки',
    urlShortenerPresetId: 'Пресет',
    mccmnc: 'MCC MNC',
    recipient: 'Получатель',
    yulore: 'Yulore',

    group: {
      pattern: 'Шаблон группы'
    },

    add: {
      condition: 'Добавить условие'
    },

    ...moderation
  },

  tags: {
    text: 'Текст',
    sender: 'Отправитель',
    recipient: 'Получатель',
    code: 'Код оператора',
    group: 'Группа оператора',
    mcc: 'MCC',
    mnc: 'MNC',
    mccmnc: 'MCC MNC',
    contactList: 'Адресные книги',
    messagePattern: 'Шаблоны для модерации',
    type: 'Тип',
    moderation: 'Модерация',
    keywords: 'Ключевые слова',
    fallbacks: 'Переотправления',
    buttons: 'Кнопки',
    urlShortenerPresetId: 'Пресет коротких ссылок',
    yulore: 'Yulore'
  },

  hints: {
    noRule: 'Условие ещё не выбрано. Нажмите на эту строку чтобы выбрать.',
    phone: 'Введите в это поле телефон для проверки его наличия в выбранных адресных книгах.',
    yulore: 'Можно вводить любые целые числа.<br>Введите число и нажмите Enter или уберите фокус - значение добавится.<br>Если число уже есть в списке, оно будет удалено.'
  },

  buttons: {
    add: {
      rule: 'Добавить правило',
      group: 'Добавить группу',
      condition: 'Добавить условие'
    },
    remove: {
      rule: 'Удалить правило',
      group: 'Удалить группу'
    }
  }
}
